<!-- DESC：向投稿者发邮件页面 -->
<template>
    <div class="submissionEmail-container">
        <!-- 页面信息描述 -->
        <el-row justify="center">
            <el-col :span="21" class="login-title">
                <div class="desc-box">
                    <div class="title">Email to Authors of Submission {{ route.query.autoid }}</div>
                    <br />
                    <div class="info">
                        Select the authors to whom you would like to send the message. The corresponding authors are
                        marked
                        by ✔.
                    </div>
                    <div class="info">
                        Do not send any personal emails since your email will be saved in the database and visible to
                        all
                        chairs.
                    </div>
                    <div class="info">
                        Use the attachment field if you want to add a file as an attachment to this letter.
                    </div>
                </div>
            </el-col>
            <el-col :span="3" class="login-title" style="display: flex;align-items: center;justify-content: center;"
                size="small" @click="$router.back()">
                <el-button type="primary" :icon="ArrowLeftBold" circle plain></el-button>
            </el-col>
        </el-row>
        <!-- 邮件内容构建 -->
        <el-row>
            <el-col :span="15">
                <div class="email-box">
                    <!-- 标题 -->
                    <div
                        style="margin-bottom:30px;border-left: 3px solid rgba(48, 132, 158, 0.575);padding-left: 10px;">
                        Email</div>
                    <el-card shadow="always">
                        <el-form :model="emailform" label-width="91px">
                            <el-form-item label="Subject:" required>
                                <el-input v-model="emailform.subject" />
                            </el-form-item>
                            <el-form-item label="Message:" required>
                                <el-input v-model="emailform.message" type="textarea" :rows="9"
                                    :autosize="{ minRows: 9, maxRows: 20 }" resize="none" />
                                <div style="margin-top:5px">
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${id}, we will match you with the paper's id"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${id}')">${id}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${autoid}, we will match you with the paper's assigned id"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;"
                                            @click="copyinfo('${autoid}')">${autoid}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${title}, we will match you with the paper's title"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;" @click="copyinfo('${title}')">${title}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${firstname}, we will match you with the author's firstname"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;" @click="copyinfo('${firstname}')">${firstname}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${lastname}, we will match you with the author's lastname"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;" @click="copyinfo('${lastname}')">${lastname}</el-tag>
                                    </el-tooltip>
                                    <el-tooltip class="box-item" effect="dark"
                                        content="In the Message input ${authorlist}, we will match you with the author's authorlist"
                                        placement="top">
                                        <el-tag style="margin-right:10px;cursor: pointer;" @click="copyinfo('${authorlist}')">${authorlist}</el-tag>
                                    </el-tooltip>
                                </div>
                            </el-form-item>
                            <el-upload ref="uploadRef" class="upload-demo" :auto-upload="false" :limit="1"
                                :on-exceed="handleExceed" :http-request="sendemail" v-model:file-list="fileList">
                                <template #trigger>
                                    <el-text class="mx-1"
                                        style="margin-right: 10px;">Attachment:</el-text><el-button>select
                                        file</el-button>
                                </template>
                            </el-upload>
                            <el-divider border-style="dashed" />
                            <el-form-item required style="display: flex;align-items: center;">
                                <template #label>
                                    Authors:
                                </template>
                                <el-checkbox-group v-model="emailform.correspondingList"
                                    style="display: flex;flex-direction: column;">
                                    <el-checkbox v-for="item in paperinfo.authorList" :key="item.id" :label="item.email"
                                        v-model="item.isCorresponding" :checked="item.isCorresponding == 1">
                                        {{ item.firstname }}{{ item.lastname }} &lt;{{ item.email }}&gt;
                                    </el-checkbox>
                                </el-checkbox-group>
                            </el-form-item>
                        </el-form>
                        <el-divider border-style="dashed" />
                        <div style="display: flex;justify-content: center;" @click="presend"><el-button
                                type="primary">Send
                                Email</el-button>
                        </div>
                    </el-card>
                </div>
            </el-col>
        </el-row>
    </div>
</template>

<script setup>
import { ref, onMounted } from "vue"
import request from "../../network/request"
import { useStore } from 'vuex'
import { useRouter, useRoute } from "vue-router"
import { View, Document, Refresh, Position, Search, Plus, Message, ArrowLeftBold } from '@element-plus/icons-vue'
import { ElMessage, ElLoading } from 'element-plus'
import { dataBox } from 'js-tool-big-box';

const route = useRoute()
const store = useStore()

// 文件列表
const fileList = ref([])
// 邮件表单信息
const emailform = ref({
    subject: `${route.query.acronym} submission ${route.query.autoid}`, message: `Dear authors,

we have the following question about your submission
to ${route.query.acronym} entitled

${route.query.title}.



Best regards,
${store.state.user.firstname} ${store.state.user.lastname}.`, correspondingList: []
})

const emailList = ref([])
// 上传文件对象
const uploadRef = ref()
// 上传文件覆盖
const handleExceed = (files) => {
    uploadRef.value.clearFiles()
    const file = files[0]
    file.uid = 0
    uploadRef.value.handleStart(file)
}
const paperinfo = ref({})

// 发送预处理
const presend = () => {
    emailList.value = emailform.value.correspondingList
    // 空值效验
    if (!emailform.value.subject) {
        ElMessage({
            message: `subject cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (!emailform.value.message) {
        ElMessage({
            message: `message cannot be empty`,
            type: 'warning',
        })
        return
    }
    else if (emailList.value.length == 0) {
        ElMessage({
            message: `emaillist cannot be empty`,
            type: 'warning',
        })
        return
    }
    // 空文件后端传值
    if (fileList.value.length == 0) {
        let paperList = []
        paperList.push(route.query.pid)
        let data = {
            subject: emailform.value.subject,
            message: emailform.value.message,
            emailList: emailList.value,
            paperList: paperList
        }
        const loading = ElLoading.service({
            // 加载进度条
            lock: true,
            text: 'Loading',
            background: 'rgba(0, 0, 0, 0.7)',
        })
        request.post("/authoremail/sendalone", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
            if (res.code == 200) {
                ElMessage({
                    message: 'the email has been sent',
                    type: 'success',
                })
                loading.close()
            } else {
                loading.close()
            }
        })

    }
    else {
        uploadRef.value.submit()
    }
}

// 附件形式发送邮件
const sendemail = (payload) => {
    let paperList = []
    paperList.push(route.query.pid)
    let data = {
        subject: emailform.value.subject,
        message: emailform.value.message,
        emailList: [...new Set(emailList.value)].join(","),
        paperList: paperList,
        file: payload.file
    }
    const loading = ElLoading.service({
        // 加载进度条
        lock: true,
        text: 'Loading',
        background: 'rgba(0, 0, 0, 0.7)',
    })
    request.post("/authoremail/sendalone", data, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        if (res.code == 200) {
            ElMessage({
                message: 'the email has been sent',
                type: 'success',
            })
            loading.close()
        } else {
            loading.close()
        }
    })
}

// 获取论文详细信息
function getPaperDetail() {
    request.post("/paper/detail", {
        pid: route.query.pid
    }, { headers: { 'content-type': 'multipart/form-data' } }).then((res) => {
        paperinfo.value = res.data
    })
}

// 快捷复制信息
const copyinfo = (text) => {
    dataBox.copyText(text, () => {
        ElMessage({
            type: 'success',
            message: '复制成功'
        })
    })
}

onMounted(() => {
    getPaperDetail()
})

</script>

<style lang="scss">
.submissionEmail-container {
    .login-title {
        background: #b7dffd3b;
        margin-bottom: 50px;
        padding: 20px 0;

        .desc-box {
            font-size: 16px;
            padding: 0 30px;

            .title {
                font-weight: 700;
                font-size: 20px;
                padding: 0;
                -webkit-background-clip: text;
                background-clip: text;
                background-image: linear-gradient(to right, rgb(28, 31, 32), rgb(3, 79, 129));
                color: transparent;
            }

            .info {
                padding: 0;
                font-size: 14px;
                margin-bottom: 10px;
            }
        }
    }

}
</style>